import React from 'react';
import PropTypes from 'prop-types';

const TableFooter = ({optionalFooterBody, rowCount, totalCount}) => {
  return <div className={'info-container'}>
    <div className= 'col-12'>
      {optionalFooterBody}
      {(!optionalFooterBody) &&
        <p>
          Showing {rowCount} entries

          {(rowCount !== totalCount) &&
            <span> (filtered from {totalCount} total entries).</span>
          }
        </p>
      }
    </div>
  </div>;
};

TableFooter.propTypes = {
  optionalFooterBody: PropTypes.element,
  rowCount: PropTypes.number,
  totalCount: PropTypes.number,
};

export default TableFooter;
